import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui";

import styles from "./RedirectToOrder.module.scss";

export type GoToOrderButtonProps = {
  orderId: string | undefined;
};

export const GoToOrderButton: FC<GoToOrderButtonProps> = ({ orderId }) => {
  const { __ } = useTranslations();
  const { PROFILE_PAGE_URL } = useConfig();

  const userProfileOrderPageURL = `${PROFILE_PAGE_URL}#/orders/${orderId}`;

  return (
    <div className={styles.goToOrderButton}>
      <Button
        nativeBehaviour
        variant="text-muted"
        href={userProfileOrderPageURL}
        size="sm"
        aria-label={__("cart.order.summary.summaryLink", [orderId || ""])}
        iconAfter={LongArrowForwardIcon}
      >
        {__("cart.order.summary.summaryLink", [orderId || ""])}
      </Button>
    </div>
  );
};
